import { useFormikContext } from 'formik';
import { useTheme, useMediaQuery } from '@mui/material';
import { Group, RaptorJobFormValues } from '@/raptorjob/presentation/RaptorJobValidationSchema';
import { CrewAssignmentStatus } from '@/common/infrastructure/gql/generated/schema';

export const useCreateJobGroups = <T extends { groups: Group[] } = RaptorJobFormValues>() => {
  const { values, setFieldValue } = useFormikContext<T>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const hasUnavailableResources = values.groups.some((group) => {
    // Check equipment status
    const equipmentStatus = group.equipment.equipmentStatus?.toLowerCase();
    const hasUnavailableEquipment = !!equipmentStatus && equipmentStatus !== 'available' && equipmentStatus !== 'in service';

    // Check crew member status
    const hasUnavailableCrew = group.employees.some((employee) => {
      const status = employee.status || [];
      return status.includes(CrewAssignmentStatus.Banned) || status.includes(CrewAssignmentStatus.OutOfOffice);
    });

    return hasUnavailableEquipment || hasUnavailableCrew;
  });

  return {
    hasUnavailableResources,
    isMobile,
    setFieldValue,
    values
  };
};
